import React, { useEffect } from "react";
import moment from "moment";
import { amplify } from "../../service/api/AuthService";

const IdleTimer = ({ auth, timeOutInterval = 30000 }) => {
  let timer = undefined;
  const events = ["click", "load", "keydown"];

  const startTimer = () => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      let lastInteractionTime = localStorage.getItem("lastInteractionTime");
      const diff = moment.duration(moment().diff(moment(lastInteractionTime)));
      if (diff._milliseconds < timeOutInterval) {
        startTimer();
      } else {
        amplify.signOut();
      }
    }, timeOutInterval);
  };

  const eventHandler = () => {
    if (auth) {
      localStorage.setItem("lastInteractionTime", moment());
      if (timer) {
        startTimer();
      }
    }
  };

  const removeEvents = () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, eventHandler);
    });
  };

  const addEvents = () => {
    events.forEach((eventName) => {
      window.addEventListener(eventName, eventHandler);
    });

    startTimer();
  };

  useEffect(() => {
    if (auth) {
      if (!localStorage.getItem("lastInteractionTime"))
        localStorage.setItem("lastInteractionTime", moment());
      addEvents();
    }
    return () => {
      removeEvents();
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  return <></>;
};

export default IdleTimer;
